import React, { useRef } from 'react';
import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { FormRef } from '@lib/components/ReactHookForm/FormContainer';
import AssetDocumentation from 'components/AssetDocumentation/AssetDocumentation';
import useModalManagement from 'routes/Assets/AssetDocumentation/utils/useModalManagement';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import { getGraphQLErrors } from '@lib/utils/graphQLErrors';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';
import getDefaultValuesFromQueryData, {
  DEFAULT_BULK_VALUES,
} from './utils/getDefaultValuesFromQueryData';
import useActions from './utils/useActions';

export default function AssetDocumentationContainer() {
  const formRef = useRef<FormRef>(undefined);
  const useModalManagementResult = useModalManagement();
  const { getUserAccessByCompany }: ContextProps = useOutletContext();
  // The document's permission fields are BE-gated — `@skip` them for
  // LimitedRead users so the whole query doesn't fail.
  const isViewLocked =
    getUserAccessByCompany(AccessComponentEnum.DocumentationManagement) ===
    AccessLevelEnum.LimitedRead;
  const useActionsResult = useActions({
    isViewLocked,
    useModalManagementResult,
  });
  const {
    breadCrumbsData,
    destroyLoading,
    mutationError,
    documentationQueryHookResult,
    isCreatePage,
    loading,
    onConfirmedDocumentationDestroy,
    onCreateTag,
    onSubmit,
    useSearchListQueriesResult,
  } = useActionsResult;

  const defaultValues = isCreatePage
    ? DEFAULT_BULK_VALUES
    : getDefaultValuesFromQueryData(documentationQueryHookResult.data);

  return (
    <>
      <BreadCrumbs data={breadCrumbsData} />
      <AssetDocumentation
        defaultValues={defaultValues}
        destroyLoading={destroyLoading}
        documentation={documentationQueryHookResult.data}
        documentError={documentationQueryHookResult.error}
        formRef={formRef}
        graphQLErrors={getGraphQLErrors(mutationError)}
        isCreatePage={isCreatePage}
        loading={loading}
        onConfirmedDocumentationDestroy={onConfirmedDocumentationDestroy}
        onCreateTag={onCreateTag}
        onSubmit={onSubmit}
        tagsLoadOptions={useSearchListQueriesResult.tagsLoadOptions}
        useModalManagementResult={useModalManagementResult}
      />
    </>
  );
}
